export class BackupPostureControlResourceSelector {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "resourceSelectionMode",
            "baseName": "resourceSelectionMode",
            "type": "ResourceSelectorMode",
            "format": ""
        },
        {
            "name": "expression",
            "baseName": "expression",
            "type": "BackupPostureControlExpression",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return BackupPostureControlResourceSelector.attributeTypeMap;
    }
    constructor() {
    }
}
